import { createAction, createActionGroup, props } from "@ngrx/store";
import { Auth } from "../../auth/primitives/auth";
import { Vector2, Vector3 } from "three";
import {UserModel} from "./user.model";

export const UsersActions = createActionGroup({
  source: "Users",
  events: {
    "Found User": props<{ user: UserModel }>(),
    "Updated User": props<{ user: UserModel }>(),
    "Subscribe To User": props<{ userId: string }>(),
  },
});
